import { createContext, useContext, useState, useCallback } from "react";
import axios from "axios";

const StockMarketCapContext = createContext(null);
const BASE_URL = process.env.REACT_APP_API_BASE_URL;

export const NASDAQ100 = [
  "AAPL",
  "MSFT",
  "AMZN",
  "NVDA",
  "GOOGL",
  "GOOG",
  "META",
  "TSLA",
  "AVGO",
  "COST",
  "PEP",
  "ADBE",
  "CSCO",
  "NFLX",
  "AMD",
  "INTC",
  "QCOM",
  "TXN",
  "AMAT",
  "ADI",
  "INTU",
  "MU",
  "LRCX",
  "BKNG",
  "ISRG",
  "MDLZ",
  "GILD",
  "REGN",
  "VRTX",
  "SBUX",
  "PYPL",
  "PANW",
  "SNPS",
  "CDNS",
  "KLAC",
  "MAR",
  "ORLY",
  "MNST",
  "ASML",
  "CTAS",
  "DXCM",
  "BIIB",
  "EA",
  "MRVL",
  "KDP",
  "FTNT",
  "ADP",
  "PAYX",
  "WDAY",
  "IDXX",
  "ROST",
  "XEL",
  "ODFL",
  "ANSS",
  "CSX",
  "FANG",
  "CHTR",
  "EXC",
  "BKR",
  "ILMN",
  "DLTR",
  "PCAR",
  "VRSK",
  "WBA",
  "FAST",
  "MELI",
  "EBAY",
  "SIRI",
  "TEAM",
  "NXPI",
  "OKTA",
  "ZS",
  "DDOG",
  "CRWD",
  "ABNB",
  "GEHC",
  "LULU",
  "CPRT",
  "ENPH",
];

export const StockMarketCapProvider = ({ children }) => {
  const [marketCapStore, setMarketCapStore] = useState({});
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  const fetchNasdaqMarketCap = useCallback(async () => {
    if (!BASE_URL) {
      setError("API base URL not configured");
      return;
    }

    setLoading(true);
    setError(null);

    for (const symbol of NASDAQ100) {
      try {
        const res = await axios.get(`${BASE_URL}/api/stockoverview`, {
          params: { symbol },
        });

        setMarketCapStore((prev) => ({
          ...prev,
          [symbol]: {
            symbol,
            marketCap: res.data?.MarketCapitalization
              ? Number(res.data.MarketCapitalization)
              : null,
            sector: res.data?.Sector ?? "N/A",
            industry: res.data?.Industry ?? "N/A",
          },
        }));
      } catch (err) {
        console.error(`❌ MarketCap failed for ${symbol}`);
      }

      // ✅ AlphaVantage safe delay
      await new Promise((r) => setTimeout(r, 900));
    }

    setLoading(false);
  }, []);

  return (
    <StockMarketCapContext.Provider
      value={{
        marketCapStore,
        fetchNasdaqMarketCap,
        loading,
        error,
        total: NASDAQ100.length,
        loadedCount: Object.keys(marketCapStore).length,
      }}
    >
      {children}
    </StockMarketCapContext.Provider>
  );
};

export const useStockMarketCap = () => useContext(StockMarketCapContext);
